// Partner Feedback

export const OPEN_FEEDBACK_COLLECTOR = 'openFeedbackCollector';
export const SUBMIT_FEEDBACK_COLLECTOR = 'submitFeedbackCollector';